import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-hand',
	templateUrl: './icon-hand.component.svg',
})
export class IconHandComponent {}
